import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Symbol from 'core/components/Symbol'

import Wrapper from 'core/components/SecondaryHeader/components/SocialIcons/components/Styled'

class SocialIcons extends Component {
  static defaultProps = {
    socialData: {}
  }

  static propTypes = {
    socialData: PropTypes.object
  }

  getSocialData () {
    if (Object.keys(this.props.socialData).length) {
      return `&media=${encodeURIComponent(this.props.socialData.image)}&description=${encodeURIComponent(this.props.socialData.description)}`
    }

    return ''
  }

  render () {
    return (
      <Wrapper>
        <div>
          Share this page
        </div>
        <div>
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location}`} rel='noopener noreferrer' target='_blank'><Symbol name='icon-facebook-blue' /></a>
          <a href={`https://twitter.com/share?url=${window.location}`} rel='noopener noreferrer' target='_blank'><Symbol name='icon-twitter-blue' /></a>
          <a href={`https://pinterest.com/pin/create/button/?url=${window.location + this.getSocialData()}`} rel='noopener noreferrer' target='_blank'><Symbol name='icon-pinterest-blue' /></a>
        </div>
      </Wrapper>
    )
  }
}

export default SocialIcons
